import React from 'react'
import styles from './Card.module.css'

/**
 * Generic card component that can be clickable
 */
type CardProps = {
    /** The content to be rendered inside the container */
    children: React.ReactNode;
    /** Additional CSS classes for custom styling (optional) */
    className?: string;
    /** Click handler for the card (optional) */
    onClick?: () => void;
    /** Whether the card should show hover effects (optional) */
    hoverable?: boolean;
    /** Whether the card is disabled (optional) */
    disabled?: boolean;
    /** Variant of the card (default: 'default') */
    variant?: 'default' | 'full';
}

export function Card({
    children,
    className = "",
    onClick,
    hoverable = false,
    disabled = false,
    variant = 'default'
}: CardProps) {
    const cardClasses = [
        styles.card,
        className,
        hoverable || onClick ? styles.hoverable : '',
        disabled ? styles.disabled : '',
        variant === 'full' ? styles.full : ''
    ].filter(Boolean).join(' ');

    return (
        <div
            className={cardClasses}
            onClick={!disabled && onClick ? onClick : undefined}
            role={onClick ? "button" : undefined}
            tabIndex={onClick && !disabled ? 0 : undefined}
            onKeyPress={
                onClick && !disabled
                    ? (e) => {
                        if (e.key === 'Enter' || e.key === ' ') {
                            onClick();
                        }
                    }
                    : undefined
            }
        >
            {children}
        </div>
    )
}
